import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HeaderData } from 'src/app/_models/header-data';
import { DatePipe } from '@angular/common';
import { PolicyService } from 'src/app/_services/policy.service';
import { StatusCode, Modules, PSIOperators } from 'src/app/_common/_enum/module.enum';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';

@Component({
  selector: 'app-policy-details',
  templateUrl: './policy-details.component.html',
  styleUrls: ['./policy-details.component.scss']
})
export class PolicyDetailsComponent implements OnInit, OnDestroy {

  public policyNumber: string;
  public policyDetails;
  public policyStatus: string;
  private loading: boolean = false;
  private reportLoading: boolean = false;
  private hasAccess: boolean = true;
  private selectedPolicy: any;
  private selectedAccount: any;
  
  resultsNotFound = RESULTS_NOT_FOUND;

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  //private killServicesOnDestroy = [];

  @ViewChild("lossRunErrorModal", {static: false}) lossRunErrorModal;
  @ViewChild("lossRunMessageModal", {static: false}) lossRunMessageModal;
  //@ViewChild("internalServerErrorModal", {static: false}) InternalServerErrorModalComponent;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, 
    private policyService: PolicyService) { }

  ngOnInit() {
    this.headerData = new HeaderData();
    //Getting Policy Number for State params
    this.route.paramMap.subscribe(params => {      
      if(this.policyNumber !== params.get("id").toString()){
        this.policyNumber = params.get("id").toString();
      }
      
      this.selectedAccount = this.policyService.getAccountData();
      //Setting Page Details
      this.setPolicyDetailsData();
    });
  }

  setHeaderData(details?: any){
    this.headerData.pageTitle = this.policyNumber;
    if(details){
      let pipe = new DatePipe('en-US');
      this.headerData.breadcrumb = [{ itemName: details.accountName, itemLink: (details.accountNumber != undefined)?("/accounts/" + details.accountNumber + "/policies"):""}, {itemName:"Policies", itemLink:""}];
      this.headerData.detailMenu = [{label: "Account #", description: this.selectedPolicy.accountNumber}, {label: "Effective", description: pipe.transform(details.policyEffectiveDate, 'MM/dd/yyyy')}, {label: "Expiration", description: pipe.transform(details.policyExpirationDate, 'MM/dd/yyyy')}];
    }
    this.policyService.header = this.headerData;  
  }

  setPolicyHeader(_policyDetails: any) {
    this.policyDetails = _policyDetails;
    if(this.policyDetails) {
      this.setHeaderData(this.policyDetails);   /* Setting Headers */
    }    
  }

  fetchPolicyDetails() {
    this.loading = true;
    this.hasAccess = true;
    let policyDetailsSubscription = this.policyService.fetchPolicyDetails(this.policyNumber).subscribe(response => {
      this.loading = false;
      this.setPolicyHeader(response);
      if(this.policyDetails){
        this.policyService.storeAccountData({accountNumber: this.policyDetails.accountNumber, accountName: this.policyDetails.accountName, "accountEndorsementsTab": ((this.selectedAccount && this.selectedAccount.accountEndorsementsTab != null)?this.selectedAccount.accountEndorsementsTab: null)});
      }
      this.policyService.storePolicyData(this.policyDetails);
      },error=>{
        this.loading = false;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.policyService.runningServices.push(policyDetailsSubscription);
  }

  get ModuleEnum(){ return Modules; }
  get PSIOperatorsEnum(){ return PSIOperators;  }
  /*
    * Steps for below function
    * First it gets data from session storage and sets in this.selectedPolicy
    * Then it will set initial header data so that we don't see blank header with no breadcrumb information
    * Then it checks if there is financial data in session storage variable (this.selectedPolicy) 
    * and if its undefined it makes an API call to fetch data 
    * Else it will pull policy details from session storage variable this.selectedPolicy
  */
  setPolicyDetailsData() {
    // Getting Policy data from session storage
    this.selectedPolicy = this.policyService.getPolicyData();

    if(this.selectedPolicy && this.policyNumber === this.selectedPolicy.policyNumber) {
      this.setHeaderData(this.selectedAccount);

      if (!this.selectedPolicy.financial && this.selectedPolicy.financial !== "undefined") {
        this.fetchPolicyDetails();
      }else{
        this.policyDetails = this.selectedPolicy;
        this.setPolicyHeader(this.selectedPolicy); // sets initial header data only
      }
    } else {
      this.fetchPolicyDetails();
    }
  }
  
  openDirectBill(_policyDetails){
    this.policyService.storeAccountData({accountName: _policyDetails.accountName, accountNumber: _policyDetails.accountNumber, "accountEndorsementsTab": null});
    this.router.navigateByUrl("accounts/"+_policyDetails.accountNumber + "/directbill");
  }

  downloadLossRunReport(type: string){
    this.reportLoading = true;
    let number = type === "policy" ? this.policyNumber : this.policyDetails.accountNumber;
    this.policyService.openModal('none', this.lossRunMessageModal);

    this.policyService.downloadLossRunReport(number, (type+"Number")).subscribe(data=>{
      this.reportLoading = false;
      this.policyService.closeModal();
    },
    error => {
      this.reportLoading = false;
      let hasOpenModals = this.policyService.hasOpenModals();
      if (hasOpenModals) {
        this.policyService.closeModal();
      }
      if(error.status == StatusCode.NoAccess) {
        setTimeout(() => {
          this.policyService.openModal('none', this.lossRunErrorModal);
        }, 50);        
      }
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.policyService.openModal('error', 'none');
        }, 50);
      }
      console.warn("Download Loss Run Report Error : " + error);
    });
  }

  openPriorPolicyDetails(_policyNumber){
    this.router.navigate(["/policies/"+_policyNumber]);//, {skipLocationChange: true}
  }

  ngOnDestroy() {
    this.policyService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}